<!-- 
  详情页 - 客户阶段
  props:
 -->

<template>
  <!-- 客户阶段 -->
  <div class="oppo-stage">
    <ul class="stage-list">
      <template v-for="item in customerStage.allStageArray">
        <li class="option" v-if="item.type === 2" :key="item.id" :class="{'item lose-tag': item.finishStatus === 2}">
          <a href="javascript:;" class="link" @click="jumpConfirm(item)">流失</a>
        </li>
        <li
          v-else
          class="item"
          :key="item.id"
          @click="isChangeStage(item)"
          :class="{'progress': (item.finishStatus === 1 || item.finishStatus === 2) && customerStage.type !== 2}">
          <span class="name">{{item.name}}</span>
          <!-- 阶段提醒浮窗 -->
          <ul class="mini-modal" v-if="item.stage.into_time">
            <li class="p break-all">
              <span class="label">阶段用时：</span>
              <span class="text">{{item.stage.into_time}}~{{item.stage.out_time}}</span>
            </li>
            <li class="p">
              <span class="label">停留时间：</span>
              <span class="text">{{item.stage.stayTime}}</span>
            </li>
            <li class="p">
              <span class="label">工作情况：</span>
              <span class="text">{{item.stage.workFinish.finish}}/{{item.stage.workFinish.total}}</span>
            </li>
          </ul>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import * as api from 'src/api'
import { Message, MessageBox } from 'element-ui'

export default {
  props: {
    customerStage: {
      type: Object,
      default: () => {}
    },
    customerType: {
      type: String,
      default: 'customer'
    },
    customerId: {
      type: Number
    }
  },
  data () {
    return {
      permission: this.customerStage.permission
    }
  },
  methods: {
    jumpConfirm () {
      if (this.customerType === 'isPublic') {
        Message(`对不起，公海客户不允许更改客户阶段`)
        return
      } else if (!this.permission) {
        Message(`对不起，您没有权限进行阶段跳转`)
        return
      } else if (this.customerStage.type === 2) {
        Message(`当前已是流失阶段`)
        return
      }
      this.$emit('openLoseBecause')
    },
    // 判断是否更改客户阶段
    isChangeStage (item) {
      if (item.finishStatus === 2) {
        Message(`当前已是${item.name}阶段`)
        return
      }
      if (this.customerType === 'isPublic') {
        Message(`对不起，公海客户不允许更改客户阶段`)
        return
      } else if (!this.permission) {
        Message(`对不起，您没有权限进行阶段跳转`)
        return
      }
      if (this.customerStage.changeStage || item.finishStatus === 1) {
        MessageBox.confirm(`确认跳转到"${item.name}"阶段吗？`, '客户阶段变更', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.changeStage(item)
        }).catch(() => {
        })
      } else {
        MessageBox.alert(`当前阶段还存在未完成的必做工作，不允许跳转到其他阶段`, '客户阶段变更', {
          confirmButtonText: '知道了',
          callback: action => {
          }
        })
      }
    },
    // 更改客户阶段
    changeStage (item) {
      let url = `/customerStage/changeStage.html`
      let params = {
        customerId: this.customerId,
        nextStageId: item.id,
        reasonId: '',
        memo: ''
      }
      api.post(url, params, (data) => {
        Message({
          type: 'success',
          message: data.msg || '操作成功!'
        })
        this.$emit('refresh')
        if (item.type === 1) {
          this.isCreateContract()
        }
      })
    },
    // 是否创建合同
    isCreateContract () {
      MessageBox.confirm(`该客户已经成交，是否生成合同`, '生成合同确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        let params = {
          refId: this.customerId,
          module: 'contractApi',
          type: 'customerApi'
        }
        this.$emit('createContract', params)
      }).catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/less/detail.less';
  .oppo-stage {
    .lose-tag {
      margin-left: 0 !important;
      background: #E51C23 100% !important;
      font-size: 14px !important;
      .link {
        color: #ffffff !important;
      }
      &:after {
        border-color: transparent transparent transparent #E51C23 !important;
      }
    }
    border: 5px solid #dce1e8;
    border-bottom: 0;
    padding: 10px 15px 10px 40px;
    .stage-list {
      display: flex;
      flex-wrap: wrap;
      .item {
        position: relative;
        font-size: 13px;
        line-height: 32px;
        padding-left: 40px;
        padding-right: 20px;
        background-color: #f5f5f5;
        margin: 5px 16px 5px 0;
        cursor: pointer;
        transition: opacity 0.2s;
        &:hover {
          .mini-modal {
            display: block;
          }
        }
        &:after,
        &:before {
          content: "";
          position: absolute;
          border-width: 16px;
          border-style: solid;
          top: 0;
        }
        &:before {
          border-color: transparent transparent transparent #ffffff;
          left: 0px;
        }
        &:after {
          border-color: transparent transparent transparent #f5f5f5;
          right: -31px;
        }
        &.progress {
          background-color: @bg-orange;
          color: #fff;
          &:after {
            border-left-color: @bg-orange;
          }
        }
        &:first-child {
          padding-left: 20px;
          &:before {
            border-color: #f5f5f5;
            border-radius: 16px;
            overflow: hidden;
            left: -16px;
          }
          &.progress {
            &:before {
              border-color: @bg-orange;
            }
          }
        }
        .mini-modal {
          position: absolute;
          box-sizing: border-box;
          width: 250px;
          min-height: 100px;
          border-radius: 2px;
          background-color: #fff;
          box-shadow: 0 0 6px 0 rgba(105, 105, 105, 0.5);
          padding: 8px 12px 6px;
          font-size: 13px;
          left: 0;
          margin-left: -50%;
          top: 45px;
          z-index: 200;
          display: none;
          &:before {
            position: absolute;
            left: 50%;
            margin-left: -16px;
            top: -8px;
            content: "";
            width: 16px;
            height: 16px;
            transform: rotate(45deg);
            background-color: #fff;
            box-shadow: 0 0 4px 0 rgba(105, 105, 105, 0.5);
            z-index: -1;
          }
          &:after {
            position: absolute;
            left: 50%;
            margin-left: -21px;
            top: 0px;
            content: "";
            width: 26px;
            height: 12px;
            background-color: #fff;
          }
          .p {
            height: 26px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            &.break-all {
              white-space: normal;
              height: auto;
            }
            .label {
              color: @light-gray;
              margin-right: 2px;
            }
            .text {
              font-size: 13px;
              color: #666;
            }
          }
        }
      }
      .lastedtime {
        margin-top: 5px;
        margin-left: 12px;
        line-height: 30px;
        font-size: 15px;
      }
      .option {
        line-height: 32px;
        margin-left: 20px;
        margin-top: 5px;
        .link {
          margin: 0 5px;
          font-size: 14px;
          &.cancel {
            color: #666;
          }
          &:hover {
            text-decoration: underline;
          }
        }
      }
      &.disable {
        .item {
          color: @light-gray;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// customer-stage-flow.vue?53a2e1ff